export const ROUTES = {
  ABOUT: '/',
  SKILLSET: '/skillset',
  EXPERIENCE: '/experience',
  CONTACT: '/contact',
};
